export enum SearchParams {
	deliveryOptionType = "deliveryOptionType",
	deliveryOptionId = "deliveryOptionId",
	showMenuSectionList = "showMenuSectionList",
	signInWithCartId = "signInWithCartId",
	continueUrl = "continueUrl",
	registeredUserPurchase = "registeredUserPurchase",
	view = "view",
}
